import { type QuizAttemptsDocument } from "@src/appV2/FacilityRules/types";

import { type LicenseDetails } from "./license.types";
import { type WorkerDocument } from "./workerDocument.types";

// eslint-disable-next-line no-restricted-syntax
export enum DocumentType {
  DOCUMENT = "DOCUMENT",
  LICENSE = "LICENSE",
  QUIZ_ATTEMPTS = "QUIZ_ATTEMPTS",
}

// eslint-disable-next-line no-restricted-syntax
export enum DownloadRequestStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

// eslint-disable-next-line no-restricted-syntax
export enum PageActions {
  VIEW = "view",
  DOWNLOAD = "download",
  PRINT = "print",
  DOWNLOAD_SELECTED = "downloadSelected",
  PRINT_SELECTED = "printSelected",
  VIEW_NEXT = "viewNext",
  VIEW_PREV = "viewPrev",
}

// eslint-disable-next-line no-restricted-syntax
export enum ViewType {
  LIST = "list",
}

// eslint-disable-next-line no-restricted-syntax
export enum DownloadResultType {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export interface DocumentWithId {
  document: WorkerDocument | LicenseDetails | QuizAttemptsDocument;
  documentId: string;
  documentType: DocumentType;
}

export interface DocumentPrefetchedData {
  distributionUrl?: string;
  createdAt: number;
  inMemoryObjectUrl?: string;
  isValid: boolean;
}
